import {
  Dialog,
  DialogTitle,
  CircularProgress,
  Tooltip,
  Box,
  Stack,
  Typography,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import { getInspStatusImage } from "../../services/inspectService.js";
import { formatDate, truncateString } from "../../utils/util.js";

export default function InspStatReportModal({
  uuid,
  openModal,
  setOpenModal,
  selectedData,
  selectedImagePath,
  image,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (selectedData && selectedData.path) {
          const ImageResponse = await getInspStatusImage(selectedData.path);
          setImageSrc(ImageResponse);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [selectedData]);

  const handleDownloadImage = () => {
    const fileName = selectedData.path.split("/").pop();

    if (selectedData.path) {
      const link = document.createElement("a");
      link.href = imageSrc;
      link.download = fileName;
      link.click();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      {isLoading && !selectedData ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress style={{ color: "var(--text-color)" }} />
        </div>
      ) : (
        <Dialog open={openModal} onClose={() => setOpenModal(false)}>
          <Box sx={{ p: 2 }}>
            <Stack spacing={2}>
              {selectedData && (
                <>
                  <Box className="input-container">
                    <Tooltip title={selectedData.name}>
                      <Typography variant="h6" fontWeight={700}>
                        [{selectedData.id},{" "}
                        {truncateString(selectedData.name, 20)} ]
                      </Typography>
                    </Tooltip>
                  </Box>
                  <Stack direction="row" spacing={2}>
                    <Box sx={{ width: "60%", minWidth: "fit-content" }}>
                      <Stack spacing={1}>
                        <Box className="input-container">
                          <Typography className="modal-option-title">
                            Client IP
                          </Typography>
                          <Typography className="custom-text">
                            {selectedData.client_ip}
                          </Typography>
                        </Box>
                        <Box className="input-container">
                          <Typography className="modal-option-title">
                            Material Name
                          </Typography>
                          <Typography className="custom-text">
                            {localStorage.getItem("demoMode") === "true"
                              ? "***"
                              : selectedData.material_name}
                          </Typography>
                        </Box>
                        <Box className="input-container">
                          <Typography className="modal-option-title">
                            AVI Label
                          </Typography>
                          <Typography className="custom-text">
                            {truncateString(selectedData.avi)}
                          </Typography>
                        </Box>
                        <Box className="input-container">
                          <Typography className="modal-option-title">
                            AI Label
                          </Typography>
                          <Typography className="custom-text">
                            {truncateString(selectedData.label)}
                          </Typography>
                        </Box>
                        <Box className="input-container">
                          <Typography className="modal-option-title">
                            검사일자
                          </Typography>
                          <Typography className="custom-text">
                            {truncateString(formatDate(selectedData.create_at))}
                          </Typography>
                        </Box>
                        <Button
                          variant="outlined"
                          onClick={handleDownloadImage}
                        >
                          이미지 다운로드
                        </Button>
                      </Stack>
                    </Box>
                    <Box sx={{ width: "100%", mt: 2.5 }}>
                      {imageSrc ? (
                        <Box
                          component="img"
                          src={imageSrc}
                          alt="Inspection Status"
                          sx={{
                            width: "100%",
                            height: "100%",
                            filter:
                              localStorage.getItem("demoMode") === "true"
                                ? "blur(3px)"
                                : "none",
                          }}
                        />
                      ) : (
                        <Typography>Loading...</Typography>
                      )}
                    </Box>
                  </Stack>
                </>
              )}
            </Stack>
          </Box>
        </Dialog>
      )}
    </Box>
  );
}
